import { ReactNode } from "react";
import classNames from 'classnames';

import "./tooltip.scss";

export enum TooltipPositions {
	topCenter = "top-center",
	topRight = "top-right",
	bottomCenter = "bottom-center",
	bottomLeft = "bottom-left",
	left = "left",
	right = "right",
}
export interface ITooltipProps {
	tooltip: JSX.Element | string;
	children: ReactNode;
	disable?: boolean;
	position?: TooltipPositions | string;
	textClassName?: string;
}

export const Tooltip = ({ textClassName, tooltip, children, disable, position }: ITooltipProps): JSX.Element => {

	if (disable) return <>{children}</>;
	return (
		<div className={classNames("smart-tooltip", position ? position : "top-center")}>
			{/* {typeof image === "function" ? (
				image()
			) : (
				<img
					src={image as string}
					alt="tooltip"
					height="18px"
					width="auto"
				/>
			)} */}
			{children}
			<span className="smart-tooltip-content">
				<span className={classNames(textClassName, "smart-tooltip-text")}>{tooltip}</span>
			</span>
		</div>
	);
};
